import { StatsDetailsTabEnum } from '@/features/gateway/types'
import { useCurrentReflection } from '@/hooks'
import { useApiQuery } from '@/utils/use-api-query'
import { $t } from 'packages/locale'
import { FC, useContext } from 'react'

import { IndexBoardCard } from '../components/IndexBoardCard'
import { DataBoardContext } from '../context'
import { useStatsApiQuery } from '../utils/query'

/**
 * 教师考勤卡片
 *
 * @returns card
 */
export const TeacherAttendanceCard: FC<{ style?: React.CSSProperties }> = ({
  style,
}) => {
  const { semesterInfo, timeRange } = useContext(DataBoardContext)
  const reflection = useCurrentReflection()

  const apiQuery = useStatsApiQuery({
    timeRange,
    semesterInfo,
  })

  const { data: res, loading } = useApiQuery({
    apiName: 'queryAdvisorTeacherAttendanceStats',
    params: {
      query: apiQuery,
    },
    options: {
      enabled: !!reflection?.usin,
    },
  })

  const { data: attendance } = res || {}

  // 总教师人数
  const total =
    attendance?.reduce((acc, item) => acc + (item.teacher_count ?? 0), 0) ?? 0

  // has_pending_lesson === 1 代表本记录统计的是未考勤老师，0 代表本记录统计的是未考勤课节
  const itemInfo = attendance?.find(
    (item) => Number(item.has_pending_lesson ?? 0) === 1
  )

  return (
    <IndexBoardCard
      title={$t('教师考勤统计')}
      count={total}
      items={[
        {
          label: $t('未考勤教师'),
          value: itemInfo?.teacher_count ?? 0,
          unit: $t('人'),
        },
        {
          label: $t('未考勤课节'),
          value: itemInfo?.total_pending_lesson ?? 0,
          unit: $t('节'),
        },
      ]}
      type={StatsDetailsTabEnum.TeacherAttendance}
      loading={loading}
      flex={1}
      style={style}
      itemIconMsg={{
        name: 'AddressBook',
        color: '#842DE0',
        backgroundColor: '#F7E8FF',
      }}
    />
  )
}
